/** レコメンド用Cookie更新. */
export const UPDATE_RECOMMEND_COOKIE = "UPDATE_RECOMMEND_COOKIE";